// Intl.NumberFormat defaults to halfExpand rounding, so display values can
// round up past the configured decimal places (e.g. "99.9960" at 2 dp → "100,00"
// instead of "99,99"). Truncate on the stored string before formatting; storage
// and calculations keep the full-precision value unchanged.
export function truncateDecimalString(
    value: string,
    decimalPlaces: number
): string {
    const [intPart = '0', fracPart = ''] = value.split('.')

    if (decimalPlaces <= 0) {
        return intPart || '0'
    }

    const truncatedFrac = fracPart
        .slice(0, decimalPlaces)
        .padEnd(decimalPlaces, '0')

    return `${intPart || '0'}.${truncatedFrac}`
}
